var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#5626C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.289 17.8234C11.1137 17.7074 11.0097 17.5445 11.0006 17.3716C10.9916 17.1987 11.0782 17.0304 11.2408 16.9049L14.8955 14.0083L11.281 11.1117C10.9298 10.8505 10.9298 10.431 11.281 10.1698C11.6455 9.93037 12.2034 9.94599 12.542 10.2051L16.759 13.5373C16.9146 13.6607 17.0006 13.8227 17 13.9907C17.0002 14.1569 16.914 14.3169 16.759 14.4381L12.542 17.7881C12.3755 17.9192 12.1438 17.9957 11.8994 18C11.6727 18.0002 11.4544 17.937 11.289 17.8234Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.4c85bcadff0b6f9adce00a9b0ac74cc5.svg";
export { ForwardRef as ReactComponent };